import { template as template_84689e5a2dfe4f58a9c159b065023cc8 } from "@ember/template-compiler";
import BsPopover from 'eflex/components/bs-popover';
import { withDefault, isPresent } from '@eflexsystems/ember-composable-helpers';
import Link from 'eflex/components/link';
export default template_84689e5a2dfe4f58a9c159b065023cc8(`
<a
  tabindex='0'
  class="badge bg-{{withDefault @type 'primary'}} pointer text-decoration-none rounded"
  ...attributes
>
  {{@label}}
  {{#if (isPresent @options)}}
    <BsPopover @triggerEvents='focus'>
      {{#each @options as |option|}}
        <div class="mb-1">
          <Link class="popover-link" @route={{@route}} @model={{option.id}}>{{yield option}}</Link>
        </div>
      {{/each}}
    </BsPopover>
  {{/if}}
</a>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
